import { gql } from '@efficiently/client-core-graphql-models';

export const GET_PIN_DATA = gql(`
	query GetPinData($projectId: String!) {
		getPinData(projectId: $projectId) {
			s3ParsedTextKey
			planItems {
				...PlanItemFields
			}
		}
	}
`);
